var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',[_c('PaymentFullCoin',{attrs:{"loyaltyUsage":_vm.loyaltyUsage,"subTotal":_vm.subTotal,"detailOrder":_vm.data}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }